<template>
  <el-menu :default-active="$route.name">
    <item v-for="menu in menus" :key="menu.name" :menu="menu"></item>
  </el-menu>
</template>

<script>
import mixin from '@/mixins/layout'
import item from './item'

export default {
  name: 'side-bar',
  components: { item },
  mixins: [mixin]
}
</script>